// import Box from "@mui/material/Box";
// import isString from "lodash/isString";
// import PropTypes from "prop-types";
// import { useCallback, useMemo } from "react";
// import { NavLink, useLocation } from "react-router-dom";

// const LoanDrilldownRouterTabSwitcher = ({
//   tabs,
//   baseUrl = "/loan/",
//   orientation = "horizontal",
//   variant = "background",
//   underlinePosition = "bottom",
// }) => {
//   const location = useLocation();

//   const currentPath = useMemo(
//     () => location.pathname.replace(/&/g, "and").replace(/\/$/, ""),
//     [location.pathname],
//   );

//   const cleanBase = useMemo(
//     () => baseUrl.replace(/&/g, "and").replace(/\/$/, ""),
//     [baseUrl],
//   );

//   const styles = useMemo(() => {
//     return {
//       display: "flex",
//       flexDirection: orientation === "horizontal" ? "row" : "column",
//       ".nav-link": {
//         fontFamily: "var(--ibm)",
//         color: "#181d1f",
//         fontWeight: 400,
//         fontSize: "11px",
//         // fontSize: "13px",
//         p: 1.5,
//         borderRadius: 0,
//         whiteSpace: "nowrap",
//         textDecoration: "none",
//         transition: "all 0.2s ease",

//         ...(orientation === "vertical" && {
//           whiteSpace: "nowrap",
//           minWidth: "fit-content",
//           justifyContent: "flex-start",
//           textAlign: "left",
//           borderLeft: "2px solid transparent",
//         }),

//         "&.active": {
//           color: "#2962ff",
//           fontWeight: 700,
//           borderBottom: "2px solid #2962ff",

//           ...(variant === "underline"
//             ? {
//                 background: "none",
//                 borderRadius: "0 !important",
//                 fontWeight: 500,
//               }
//             : {
//                 background: "#2962ff14",
//               }),

//           ...(variant === "underline" && {
//             ...(orientation === "horizontal" &&
//               underlinePosition === "bottom" && {
//                 borderBottom: "2px solid #2962ff",
//               }),
//             ...(orientation === "horizontal" &&
//               underlinePosition === "top" && {
//                 borderTop: "2px solid #2962ff",
//               }),
//             ...(orientation === "vertical" &&
//               underlinePosition === "left" && {
//                 borderLeft: "2px solid #2962ff",
//               }),
//             ...(orientation === "vertical" &&
//               underlinePosition === "right" && {
//                 borderRight: "2px solid #2962ff",
//               }),
//           }),
//         },
//       },
//     };
//   }, [orientation, variant, underlinePosition]);

//   const isTabActive = useCallback(
//     (tabKey, linkActive) => {
//       const isSummary = tabKey === "summary";

//       if (isSummary) {
//         return [cleanBase, `${cleanBase}/summary`].includes(currentPath);
//       }

//       // Automatically active if tabKey appears as a segment anywhere in the path
//       // Example matches:
//       //   /loan/1001/fees-and-closing/wire-instructions -> tabKey "fees-and-closing" or "wire-instructions"
//       const segmentRegex = new RegExp(`(^|/)${tabKey}(/|$)`);
//       return (
//         (currentPath.startsWith(cleanBase) &&
//           segmentRegex.test(currentPath.replace(cleanBase, ""))) || // only look after base
//         linkActive
//       );
//     },
//     [cleanBase, currentPath],
//   );

//   const tabItems = useMemo(() => {
//     return tabs.map((tab) => {
//       const rawKey = isString(tab) ? tab.toLowerCase() : tab.path;

//       // sanitize & -> and before turning into a slug
//       const tabKey = rawKey.replace(/&/g, "and").replace(/\s+/g, "-");

//       const label = isString(tab) ? tab : tab.label;

//       const isSummary = tabKey === "summary";
//       const to = isSummary ? cleanBase : `${cleanBase}/${tabKey}`;

//       return {
//         tabKey,
//         label,
//         to,
//         isSummary,
//       };
//     });
//   }, [tabs, cleanBase]);

//   return (
//     <Box sx={styles}>
//       {tabItems.map(({ tabKey, label, to, isSummary }) => (
//         <NavLink
//           key={tabKey}
//           to={to}
//           end={!isSummary}
//           className={({ isActive: linkActive }) => {
//             const manualActive = isTabActive(tabKey, linkActive);
//             return `nav-link${manualActive ? " active" : ""}`;
//           }}
//         >
//           {label}
//         </NavLink>
//       ))}
//     </Box>
//   );
// };

// LoanDrilldownRouterTabSwitcher.propTypes = {
//   tabs: PropTypes.array.isRequired,
//   baseUrl: PropTypes.string,
//   orientation: PropTypes.oneOf(["horizontal", "vertical"]),
//   variant: PropTypes.oneOf(["background", "underline"]),
//   underlinePosition: PropTypes.oneOf(["top", "bottom", "left", "right"]),
// };

// export default LoanDrilldownRouterTabSwitcher;
import Box from "@mui/material/Box";
import isString from "lodash/isString";
import PropTypes from "prop-types";
import { useCallback, useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";

const LoanDrilldownRouterTabSwitcher = ({
  tabs,
  baseUrl = "/loan/",
  orientation = "horizontal",
  variant = "background",
  underlinePosition = "bottom",
  iconPosition = "start",
  iconSize = 15,
  iconGap = 0.45,
  // iconGap = 0.75,
}) => {
  const location = useLocation();

  const currentPath = useMemo(
    () => location.pathname.replace(/&/g, "and").replace(/\/$/, ""),
    [location.pathname],
  );

  const cleanBase = useMemo(
    () => baseUrl.replace(/&/g, "and").replace(/\/$/, ""),
    [baseUrl],
  );

  const styles = useMemo(() => {
    return {
      display: "flex",
      flexDirection: orientation === "horizontal" ? "row" : "column",
      ".nav-link": {
        fontFamily: "var(--ibm)",
        color: "#181d1f",
        fontWeight: 400,
        fontSize: "11px",
        p: 1.5,
        borderRadius: 0,
        whiteSpace: "nowrap",
        textDecoration: "none",
        transition: "all 0.2s ease",

        display: "inline-flex",
        alignItems: "center",
        gap: iconGap,

        ...(orientation === "vertical" && {
          whiteSpace: "nowrap",
          minWidth: "fit-content",
          justifyContent: "flex-start",
          textAlign: "left",
          borderLeft: "2px solid transparent",
        }),

        ".tab-icon": {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 0,
          "& svg": {
            fontSize: iconSize,
          },
        },

        "&.active": {
          color: "#2962ff",
          fontWeight: 700,
          borderBottom: "2px solid #2962ff",

          ...(variant === "underline"
            ? {
                background: "none",
                borderRadius: "0 !important",
                fontWeight: 500,
              }
            : {
                background: "#2962ff14",
              }),

          ...(variant === "underline" && {
            ...(orientation === "horizontal" &&
              underlinePosition === "bottom" && {
                borderBottom: "2px solid #2962ff",
              }),
            ...(orientation === "horizontal" &&
              underlinePosition === "top" && {
                borderTop: "2px solid #2962ff",
              }),
            ...(orientation === "vertical" &&
              underlinePosition === "left" && {
                borderLeft: "2px solid #2962ff",
              }),
            ...(orientation === "vertical" &&
              underlinePosition === "right" && {
                borderRight: "2px solid #2962ff",
              }),
          }),
        },
      },
    };
  }, [orientation, variant, underlinePosition, iconGap, iconSize]);

  const isTabActive = useCallback(
    (tabKey, linkActive) => {
      const isSummary = tabKey === "summary";

      if (isSummary) {
        return [cleanBase, `${cleanBase}/summary`].includes(currentPath);
      }

      const segmentRegex = new RegExp(`(^|/)${tabKey}(/|$)`);
      return (
        (currentPath.startsWith(cleanBase) &&
          segmentRegex.test(currentPath.replace(cleanBase, ""))) ||
        linkActive
      );
    },
    [cleanBase, currentPath],
  );

  const tabItems = useMemo(() => {
    return tabs.map((tab) => {
      const rawKey = isString(tab) ? tab.toLowerCase() : tab.path;

      // sanitize & -> and before turning into a slug
      const tabKey = rawKey.replace(/&/g, "and").replace(/\s+/g, "-");

      const label = isString(tab) ? tab : tab.label;

      // icon can be a component (e.g. HomeOutlined) or an element (<HomeOutlined />)
      const icon = isString(tab) ? null : tab.icon || null;

      const isSummary = tabKey === "summary";
      const to = isSummary ? cleanBase : `${cleanBase}/${tabKey}`;

      return {
        tabKey,
        label,
        to,
        isSummary,
        icon,
      };
    });
  }, [tabs, cleanBase]);

  const renderIcon = useCallback((icon) => {
    if (!icon) return null;

    // If they passed an element: <HomeOutlined />
    if (icon?.$$typeof) {
      return <span className="tab-icon">{icon}</span>;
    }

    // If they passed a component: HomeOutlined
    const IconComp = icon;
    return (
      <span className="tab-icon">
        <IconComp />
      </span>
    );
  }, []);

  return (
    <Box sx={styles}>
      {tabItems.map(({ tabKey, label, to, isSummary, icon }) => (
        <NavLink
          key={tabKey}
          to={to}
          end={!isSummary}
          className={({ isActive: linkActive }) => {
            const manualActive = isTabActive(tabKey, linkActive);
            return `nav-link${manualActive ? " active" : ""}`;
          }}
        >
          {iconPosition === "start" && renderIcon(icon)}
          <span>{label}</span>
          {iconPosition === "end" && renderIcon(icon)}
        </NavLink>
      ))}
    </Box>
  );
};

LoanDrilldownRouterTabSwitcher.propTypes = {
  tabs: PropTypes.array.isRequired,
  baseUrl: PropTypes.string,
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  variant: PropTypes.oneOf(["background", "underline"]),
  underlinePosition: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  iconPosition: PropTypes.oneOf(["start", "end"]),
  iconSize: PropTypes.number,
  iconGap: PropTypes.number,
};

export default LoanDrilldownRouterTabSwitcher;
